var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.goToLink}},[_c('v-list-item-content',[_c('v-list-item-title',{class:{ 'active-nav-link': _vm.is_active }},[_vm._v(_vm._s(_vm.link_display_name))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }